import React from 'react'

const Reports: React.FC = () => {
  return (
    <div className="space-y-6">
      <div className="bg-white rounded-lg shadow p-6">
        <h3 className="text-lg font-medium text-gray-900 mb-4">Sales Reports</h3>
        <p className="text-gray-600">Report generation functionality coming soon...</p>
      </div>
    </div>
  )
}

export default Reports
